
//import FrustumMeshWorker = require('./frustumMeshWorker');
import * as BABYLON from 'babylonjs';
export var RegionProjectionSize = -1;
export var PointProjectionSize = -1;
export var MeshProjectionSize = -1;

export interface TreeNode {

    id: string;
    blockId: string;
    largestEntryVolume: number;
    octantDistanceToCamera: number;
    octantProjectedSize: number;
    renderPriority: number;
    visible: boolean;
}

export interface TileNode {

    id: string;
    visibilityState: number;
}

export interface FrustumRegionPayload {

    collisionId: number;
    maximumRetry: number;
    planes: BABYLON.Plane[];
    cameraPosition: BABYLON.Vector3;
    cameraDirection: BABYLON.Vector3;
    transformation: number[];
    viewport: BABYLON.Viewport;
    lodDistances: number[];
}

export interface FrustmMeshMessage {
    taskType: WorkerTaskType;
    payload: InitPayload | FrustumMeshPayload | UpdatePayload /*any for TS under 1.4*/;
}

export enum WorkerTaskType {
    INIT,
    UPDATE,
    ORDERNODES
}

export interface WorkerReply {
    error: WorkerReplyType;
    taskType: WorkerTaskType;
    payload?: any;
}

export interface FrustumMeshReplyPayload {
    collisionId: number;
    visibleNodes: BABYLON.SmartArray<TreeNode>;
    hiddenNodes: BABYLON.SmartArray<TreeNode>;
}

export interface InitPayload {

}

export interface FrustumRegionReplyPayload {
    collisionId: number;
    visibleNodes: BABYLON.SmartArray<TileNode>;
    hiddenNodes: BABYLON.SmartArray<TileNode>;
}

export interface FrustumMeshPayload {

    collisionId: number;
    maximumRetry: number;
    planes: BABYLON.Plane[];
    cameraPosition: BABYLON.Vector3;
    cameraDirection: BABYLON.Vector3;
    transformation: number[];
    viewport: BABYLON.Viewport;
}

export interface UpdatePayload {

    //updatedBlocks: FrustumMeshWorker.OctreeBlock<TreeNode>[];
    updatedBlocks: any[];
    updatedBlockContent: { [n: string]: TreeNode; };
    removedNodes: Array<string>;
}

export enum WorkerReplyType {
    SUCCESS,
    UPDATE,
    ORDERNODES,
    UNKNOWN_ERROR
}

export class Tile3DTreeModel {
    public Root: Tile3DDetailModel;
    public ContentDetails: Tile3DContentModel[];
}

export class Tile3DDetailModel {
    public ExtentsMin: Vec3;

    public ExtentsMax: Vec3;

    public Content: string[];
    public ChildContent: string[];

    public Children: Tile3DDetailModel[];
}

export class Tile3DContentModel {
    public ExtentsMin: Vec3;
    public ExtentsMax: Vec3;
    public OntologyPartID: string;

    public LODs: Tile3DContentLODModel[]
    public ID: string;
    public Name: string;
    public ContentType: string;
}
export class Tile3DContentLODModel {
    public LODLevel: number;
    public VertexCount: number;
    public FaceCount: number;
    public SegmentCount: number;
    public FileIDs: string[];
    public MetadataFileID?: string;
    public DataType: string;
}
export class Vec3 {
    public X: number;
    public Y: number;
    public Z: number;
}